import React from "react";
import BookmarkPage from "../components/bookmarks/BookmarkPage";
import PageProps from "../lib/models/pageProps";

export default function P() {
  return <BookmarkPage />;
}
P.getInitialProps = async (): PageProps => {
  return {
    seo: {
      robots: "noindex, follow"
    }
  };
};
